import React, {useState} from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { ContainerCoverVideo, Container, TitleSub, HeaderSdg, ContainerChart } from '../../components/AppComponents';
import { figure51 } from '../../graphs/es/figure51';
import Modal from '../../components/Modal';

const Sdg10 = () => {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(false);

    const handleClickOpen = (value) => {
        setOpen(true);
        setText(value);
    };

    const handleClose = (value) => {
        setOpen(false);
        setText(value);
    };
    return (
      
        <React.Fragment>
            <Modal
                text={text}
                open={open}
                onClose={handleClose}
            />
            <ContainerCoverVideo 
                id="10" 
                poster={require('../../images/poster-sdg-10.png').default}
                video={require('../../images/video-sdg-10.mp4').default}
                sdgImage={require('../../images/EN_10.svg').default}
                sdg="OBJETIVO DE DESARROLLO SOSTENIBLE 10"
                title="Reducción de las desigualdades"
                subtitle="Reducir la desigualdad en los países y entre ellos."
                indicators={['10.a.1']}  
                indicatorsTitle="INDICADOR"
            />

<Container>
                <TitleSub title="Descripción general" />
<p>La pandemia de la COVID-19 ha hecho retroceder la tendencia de los últimos decenios de reducir la desigualdad de ingresos a escala mundial. Las recuperaciones desiguales en las distintas regiones del mundo amenazan con agravar aún más la desigualdad mundial.</p>
<p>Los que tienen ingresos relativamente bajos corren el riesgo de quedarse más rezagados. La pandemia también ha intensificado la discriminación estructural y sistémica. Los mercados emergentes y las economías en desarrollo experimentan una lenta recuperación, lo que aumenta las diferencias de ingresos entre países. Así pues, la consecución del ODS 10 requiere esfuerzos conjuntos y acelerados para abordar las causas profundas de la desigualdad tanto dentro de los países como entre ellos.</p>
 <div id="section10.a.1">
                  <HeaderSdg 
                      title="INDICADOR 10.A.1 DE LOS ODS"
                        subtitle={["Proporción de líneas arancelarias que se aplican a las importaciones de los países menos adelantados y los países en desarrollo con arancel cero", <sup>6</sup>]}
                      target={{
                          sdg: "10",
                          title: 'Meta 10.a',
                          text: 'Aplicar el principio del trato especial y diferenciado para los países en desarrollo, en particular los países menos adelantados, de conformidad con los acuerdos de la Organización Mundial del Comercio (OMC).'
                      }}
                  />
                </div>

<p><b>El acceso libre de derechos de las exportaciones de los países en desarrollo y los países menos adelantados (PMA) a los mercados internacionales ha mejorado en los últimos años, sobre todo en el caso de los productos agrícolas. Sin embargo, el crecimiento general de las exportaciones de los PMA sigue siendo preocupantemente bajo.</b></p>
<p>La meta 10.a de la Agenda 2030 tiene como objetivo mejorar las condiciones de acceso a los mercados para las exportaciones de los países en desarrollo y los PMA, otorgándoles un trato especial y diferenciado de conformidad con los acuerdos de la OMC. El indicador 10.a.1 de los ODS muestra en qué medida se aplica un trato especial y diferenciado en los aranceles de importación, y se calcula como la proporción de líneas arancelarias exentas de derechos aplicables a las importaciones de los PMA y los países en desarrollo. El indicador muestra de manera eficaz hasta qué punto los países en desarrollo y los PMA gozan de libre acceso a los mercados de los países desarrollados.</p>
<p>Como se muestra en la Figura 51, los países en desarrollo y los PMA disfrutan de un acceso total o casi total libre de derechos de aduana y de contingentes en la mayoría de los mercados internacionales. Entre 2015 y 2021, la proporción de productos exportados por los PMA que podían entrar en los mercados internacionales libres de derechos aumentó del 63,8 % al 64,1 %. Sin embargo, este aumento fue más significativo en el caso de los productos específicamente agrícolas, pasando del 69 % en 2015 al 73,6 % en 2021.</p>
<p> En cambio, esta proporción aumentó para los países en desarrollo (del 49,4 al 54,6 %) y los pequeños Estados insulares en desarrollo (PEID) (del 62,3 al 72,5 %). Durante el mismo período, la proporción de productos agrícolas exportados por los países en desarrollo y los PEID que podían entrar en los mercados internacionales exentos de derechos aumentó del 50,8 % al 55,4 % y del 62,5 % al 73,2 %, respectivamente.</p>
<p>Así pues, como se muestra en la Figura 51, el trato preferencial concedido a las exportaciones agrícolas de los países en desarrollo, los PMA, los PDL y los PEID fue ligeramente menos favorable que el concedido a otros tipos de exportaciones. No obstante, y a pesar de la mejora registrada desde 2015, el principio del trato especial y diferenciado, un motor clave para reducir la desigualdad mundial, está lejos de aplicarse plenamente. Además, conviene tener en cuenta que los avances en la expansión de las exportaciones de los PMA son lentos. Si bien las exportaciones de los PMA han crecido considerablemente desde el año 2000, su participación en el comercio mundial general se ha mantenido prácticamente estancada en el 1 % durante el último decenio. Mientras tanto, la proporción de los PMA en la población mundial ha aumentado del 10,7 % en 2000 a más del 13 % en 2020.</p>
</Container>
	                <ContainerChart
                title="Figura 51. Proporción de exportaciones de regiones con distintos niveles de desarrollo a las que se aplica un trato de arancel cero en los mercados internacionales (2015 y 2021)"
                legend={[
                    {title: '2015', color: '#fde9fb'},
                    {title: '2021', color: '#ff3399'},
                ]}
				       
			 note={<span><b>Fuente:</b> Naciones Unidas. 2023. Base de datos de los indicadores de los ODS. En: <i>División de Estadística de las Naciones Unidas</i>. Nueva York. [Consultada el 8 de junio de 2023]. <a href="https://unstats.un.org/sdgs/dataportal/database">https://unstats.un.org/sdgs/dataportal/database</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure51}
                />
            </ContainerChart>

	    <Container>
	       <div className="footnotes">
		  <p id="footnote1"><sup>6 </sup>
	     La responsabilidad del indicador 10.a.1 de los ODS corresponde al Centro de Comercio Internacional, la Conferencia de las Naciones Unidas sobre Comercio y Desarrollo, y la Organización Mundial del Comercio.
		  </p>
	       </div>
	    </Container>
	</React.Fragment>
    ) 
}


export default Sdg10;
